import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import { RootState } from '../rootReducer';
import { ITeam } from './team';
import {
  fetchTeamsListToExport
} from './teamsToExport.thunks';

export interface TeamListState {
  teams: ITeam[];
  loading: boolean;
  error: ApiError | null;
}

const initialState: TeamListState = {
  error: null,
  loading: false,
  teams: []
};

const getTeamsToExportState = (state:RootState):TeamListState => state.teams.teamsToExport;
const getError = (state:RootState):ApiError | null => getTeamsToExportState(state).error;
const getTeamsToExport = (state:RootState):ITeam[] => getTeamsToExportState(state).teams;
const getLoading = (state:RootState):boolean => getTeamsToExportState(state).loading;

export const selectors = {
  getError,
  getTeamsToExport,
  getLoading
};

export const extraReducers = {
  [fetchTeamsListToExport.pending.type]: (state: TeamListState):void => {
    state.loading = true;
    state.teams = [];
  },
  [fetchTeamsListToExport.fulfilled.type]: (state: TeamListState, action: AnyAction):void => {
    state.loading = false;
    state.teams = action.payload.teams;
  },
  [fetchTeamsListToExport.rejected.type]: (state: TeamListState, action: AnyAction):void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const teamsToExportSlice = createSlice({
  name: 'teamsToExport',
  initialState,
  reducers: {},
  extraReducers
});

export default teamsToExportSlice.reducer;
export const actions = {
  ...teamsToExportSlice.actions,
  fetchTeamsListToExport
};
